



















































































import Vue from "vue";
import { Component } from "vue-property-decorator";
import RequestService from "@/services/requestService";
import { mapGetters, mapState } from "vuex";
import ISetting from "@/interfaces/setting";
import AppSettings from "@/appsettings";

@Component({
  computed: {
    ...mapGetters("subscriptions", ["hasActiveSubscription"]),
    ...mapGetters("settings", ["selectedHttpMethod", "selectedScheme"]),
    ...mapState("settings", ["availableSchemes"]),
  },
})
export default class AddManual extends Vue {
  // computed
  hasActiveSubscription!: boolean;
  selectedHttpMethod!: string;
  selectedScheme!: string;
  availableSchemes!: Array<string>;

  urlsToAdd = "";
  dialogVisible = false;
  loading = false;

  get localAddScheme() {
    return this.selectedScheme;
  }

  set localAddScheme(newValue: string) {
    let payload = {
      key: "AddScheme",
      value: newValue,
    };

    this.updateSetting(payload).then(
      () => {
        // nothing
      },
      () => {
        this.$message({
          message: "Something went wrong while updating the scheme setting",
          type: "error",
        });
      }
    );
  }

  get maximumUrlsPerBatch(): number {
    return AppSettings.MaximumRequestsPerBatch.Free;
  }

  updateSetting(payload: ISetting) {
    return new Promise((resolve, reject) => {
      this.$store.dispatch("settings/update", payload).then(
        () => {
          resolve();
        },
        () => {
          reject();
        }
      );
    });
  }

  process() {
    this.loading = true;

    RequestService.AddRequestsFromString(
      this.urlsToAdd,
      this.selectedHttpMethod,
      this.selectedScheme,
      this.hasActiveSubscription
    );

    //
    // Add the urls
    const requests = RequestService.GetAndEmptyRequests();
    //
    // Using setTimeout for UX purposes
    setTimeout(() => {
      // clear the input field and emit 'ready' event
      this.$emit("ready", requests);
      //
      // Dispose and close
      this.loading = false;
      this.close();
    }, 950);
  }

  close() {
    this.urlsToAdd = "";
    this.dialogVisible = false;
  }
}
